<!--  -->
<template>
  <v-container fluid id="investmentContainer" class="maxWidthSet px-0">
    <TermLifeCardTitle />
    <v-card>
      <LoadingIndicator v-if="loading" :loading="loading" />
      <PrePurchaseLifeCard v-if="noLifePolicy" />
    </v-card>
    <div v-if="!loading">
      <div v-for="(policy, index) in policyStore.policies" :key="index + 'termLife'">
        <TerminatedPolicyCard v-if="policy.reinstatement" :policy-data="policy" />
        <TermLifeCard v-else-if="policy.contractId !== '0'" :index-policy="index" />
      </div>
      <AreYouProperlyProtectedCard v-if="indexPolicy === 0" :index-policy="indexPolicy" />
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import TermLifeCard from './components/TermLifeCard/TermLifeCard.vue';
import PrePurchaseLifeCard from './components/PrePurchaseLifeCard.vue';
import TermLifeCardTitle from './components/TermLifeCardTitle.vue';
import TerminatedPolicyCard from './components/TerminatedPolicy/TerminatedPolicyCard.vue';
import AreYouProperlyProtectedCard from './components/AreYouProperlyProtectedCard.vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mapStores } from 'pinia';

const componentOptions: ComponentOptions = {
  name: 'TermLife',
  components: {
    TermLifeCard,
    TermLifeCardTitle,
    PrePurchaseLifeCard,
    LoadingIndicator,
    TerminatedPolicyCard,
    AreYouProperlyProtectedCard,
  },
  props: {
    indexPolicy: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapStores(useGlobalStore, usePolicyStore),
    loading() {
      return this.policyStore.policyInfoLoading;
    },
    noLifePolicy() {
      return !this.policyStore.hasTermLife;
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.maxWidthSet {
  max-width: 1024px;
  margin: auto;
}
</style>
